export default __webpack_public_path__ + "static/kubernetes-0185ac5cb204203e97c2b2bda359d1fc.svg";